import React from "react";
import { ThemeProvider as JssThemeProvider } from "react-jss";
import BaseTheme from "../Themes/Base";

export default ({ children }) => <JssThemeProvider theme={BaseTheme}>{children}</JssThemeProvider>;
